import axios from "config/axios";

const ENDPOINT = "/authentication";

export const checkPermissionRequest = (password: string) => axios.post(`${ENDPOINT}/check`, { password });
